'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactChartjs = require('react-chartjs-2');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactChartjs.defaults.global.defaultFontStyle = 'bold';
_reactChartjs.defaults.global.defaultFontFamily = '"proxima-nova-soft", "Arial Rounded MT", "Arial", "sans-serif"';
_reactChartjs.defaults.global.defaultFontSize = 14;

var cf = function cf(num) {
  return (0, _numeral2.default)(num).format('0,0');
};

var MIN_XAXIS_DAYS = 20;

function getChartdataFromAnalytics(trackedAsset) {
  var latest = trackedAsset.statistics.slice(-100);
  var latestViews = latest.map(function (s) {
    return {
      x: Date.parse(s.createdDate),
      y: s.viewCount
    };
  });
  return latestViews;
}

var dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299'
};

function getDailyViewingFromAnalytics(trackedAsset) {
  var latest = trackedAsset.statistics.slice(-100);
  var dailyViews = [];

  _lodash2.default.forEach(latest, function (dp, idx) {
    var lastPoint = latest[idx - 1];
    // only include the data point if it's a days difference.
    if (lastPoint) {
      var d1 = (0, _moment2.default)(dp.createdDate);
      var d0 = (0, _moment2.default)(lastPoint.createdDate);
      var hoursDelta = _moment2.default.duration(d1.diff(d0)).asHours();
      if (hoursDelta > 20 && hoursDelta < 30) {
        var delta = lastPoint ? dp.viewCount - lastPoint.viewCount : 0;
        dailyViews.push({
          x: Date.parse(dp.createdDate),
          y: delta
        });
      }
    }
  });

  return dailyViews;
}

var getXAxisMin = function getXAxisMin(trackedAsset) {
  var firstStat = trackedAsset.statistics[0];
  console.log(firstStat.createdDate);
  var d1 = _moment2.default.utc(firstStat.createdDate);
  console.log('d1: ' + d1);
  console.log(d1.format('YYYY-MM-DD'));
  var d2 = _moment2.default.utc();
  console.log('d2: ' + d2);
  console.log(d2);
  console.log(d2.format('YYYY-MM-DD'));

  var min = d2.subtract(MIN_XAXIS_DAYS, 'days');

  var daysDelta = _moment2.default.duration(d2.diff(d1)).asHours();
  console.log('DD: ' + daysDelta);
  if (daysDelta > MIN_XAXIS_DAYS) {
    console.log('blah');
    min = d1;
  }

  return min;
};

var AnalyticsChart = function AnalyticsChart(_ref) {
  var trackedAsset = _ref.trackedAsset;

  if (!trackedAsset || !trackedAsset.statistics) return null;
  var analyticsData = getChartdataFromAnalytics(trackedAsset);
  var data = {
    datasets: [{
      fill: false,
      type: 'line',
      fillColor: 'rgba(38,228,184,0.05)',
      backgroundColor: 'rgba(38,228,184,0.05)',
      borderColor: 'rgba(38,228,184,1)',
      pointBorderColor: 'rgba(38,228,184,1)',
      pointBackgroundColor: '#fff',
      pointHoverBackgroundColor: 'rgba(38,228,184,1)',
      pointHoverBorderColor: 'rgba(38,228,184,1)',
      label: 'Total Views (left axis)',
      data: analyticsData,
      yAxisID: 'y-axis-1'
    }, {
      type: 'bar',
      label: 'Daily Views (right axis)',
      fillColor: dyzioPalette.bgPink,
      backgroundColor: dyzioPalette.bgPink,
      borderColor: dyzioPalette.pink,
      data: getDailyViewingFromAnalytics(trackedAsset),
      borderWidth: 1,
      yAxisID: 'y-axis-2'
    }]
  };

  var chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    tooltips: {
      mode: 'index',
      intersect: false,
      callbacks: {
        title: function title(tooltipItems) {
          return '' + (0, _moment2.default)(tooltipItems[0].xLabel).format('ddd DD MMM hh:mm');
        },
        label: function label(tooltipItem) {
          var desc = tooltipItem.datasetIndex === 0 ? 'Total Views' : 'Daily Views';
          return cf(tooltipItem.yLabel) + ' ' + desc;
        }
      }
    },
    title: {
      display: false,
      text: 'Total Viewing',
      padding: 10,
      fontSize: 18
    },
    legend: {
      display: true
    },
    elements: {
      line: {
        tension: 0
      }
    },
    layout: {
      padding: 20,
      fullWidth: false
    },
    hover: {
      mode: 'nearest',
      intersect: true
    },
    scales: {
      xAxes: [{
        type: 'time',
        ticks: {
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 5
          // callback: function(value) {
          //     return (new Date(value).getDate() % 5 == 0) ? value : null;
          // },
        },
        time: {
          displayFormats: {
            day: 'ddd DD MMM'
          },
          min: getXAxisMin(trackedAsset),
          max: (0, _moment2.default)().add(1, 'days')
        }
      }],
      yAxes: [{
        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: 'left',
        title: {
          text: 'Total Viewing'
        },
        id: 'y-axis-1'
      }, {
        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: 'right',

        id: 'y-axis-2',
        // grid line settings
        gridLines: {
          drawOnChartArea: false // only want the grid lines for one axis to show up
        }
      }]
    }
  };

  // scales: {
  //   yAxes: [{
  //     type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
  //     display: true,
  //     position: 'left',
  //     id: 'y-axis-1',
  //   }, {
  //     type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
  //     display: true,
  //     position: 'right',
  //     id: 'y-axis-2',
  //     // grid line settings
  //     gridLines: {
  //       drawOnChartArea: false, // only want the grid lines for one axis to show up
  //     },
  //   }],
  // }

  return _react2.default.createElement(_reactChartjs.Bar, { data: data, options: chartOptions });
};

exports.default = AnalyticsChart;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/youtube-watching-stats/chart/index.js
 ** module id = 2592
 ** module chunks = 0
 **/